import styled from 'styled-components';

export const AdminPanelHeadingAction = styled.div`
  align-self: flex-end;
  position: relative;
  top: -5px;
`;
